import { useEffect, useRef } from 'react';
import { Control, FieldValues, Path, UseFormGetValues, useWatch } from 'react-hook-form';

type UseFieldChangedProps<T extends FieldValues, K extends Path<T>> = {
  name: K;
  control: Control<T>;
  getValues: UseFormGetValues<T>;
  onChange: (args: { name: K; value: T[K]; allValues: T }) => void;
};

export function useFieldChanged<T extends FieldValues, K extends Path<T>>({
  name,
  control,
  onChange,
  getValues,
}: UseFieldChangedProps<T, K>) {
  const value = useWatch({ name, control });
  const prevValue = useRef(value);

  useEffect(() => {
    if (prevValue.current !== value) {
      prevValue.current = value;
      const allValues = getValues();
      onChange({ name, value, allValues });
    }
  }, [value, getValues, onChange, name]);
}
